import { Serializable } from '@/models/serializable';
import { Tag } from '@/models/tag';
import { UtilitiesFunctions } from '@/helpers';
import {toDate} from "date-fns";

export class ExperienceInquiry implements Serializable<ExperienceInquiry> {
	firstname: string;
	lastname: string;
	email: string;
	phone: string;
	privacy_profiling: boolean;
	privacy_marketing: boolean;
	message: string;
	country: object;
	experience_id: string;

	deserialize(input: any): ExperienceInquiry {
		if (!input) return;
			this.firstname = input.firstname || "";
			this.lastname = input.lastname || "";
			this.email = input.email || "";
			this.phone = input.phone || "";
			this.privacy_profiling = input.privacy_profiling || false;
			this.privacy_marketing = input.privacy_marketing || false;
			this.message = input.message || "";
			this.experience_id = input.experience_id || "";
			this.country = input.country || {};
			return this;
	}
}

